import DesWebglViewModel from 'viewmodel/DesWebglViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesWebglViewer extends DesBaseCatalogAcc {
    constructor() {
        super(DesWebglViewModel);
    }

    get src() {
        return this.getAttribute('src');
    }

    getProps() {
        return {
            src: this.src,
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            locale: this.locale
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'src'];
    }
}

if (!window.customElements.get('des-webgl-viewer')) {
    window.customElements.define('des-webgl-viewer', DesWebglViewer);
}
